import { ADD_ENTITIES } from "./types";

const addEntities = entities => ({
  type: ADD_ENTITIES,
  payload: entities
});

export default addEntities;
